module.exports = __webpack_public_path__ + "static/media/history.44df367f.png";